import i18n from '@/plugins/vue-i18n';
import { RouteRecordRaw } from 'vue-router';
import { Actions, Subjects } from '@boqnet/permissions';

import { selectedOrgId } from '@/common/utils/role.utils';
import { useFeatureFlagsStore } from '@/stores/feature-flags.store';
import { usePermissionStore } from '@/stores/permission.store';

const { t } = i18n.global;

export default [
  {
    path: '/:organisationId?/settings/account-details',
    name: 'account-details',
    component: () => import('@/views/settings/AccountSettings.vue'),
    meta: {
      title: t('routes.settings.accountSettingsPageTitle'),
      layout: 'default',
      requiresAuth: true,
      unguarded: "The signed-in user's own account settings",
    },
  },
  {
    path: '/:organisationId?/settings/organisation-details',
    name: 'organisation-details',
    component: () => import('@/views/settings/OrganisationDetails.vue'),
    meta: {
      title: t('routes.settings.organisationPageTitle'),
      layout: 'default',
      requiresAuth: true,
      action: Actions.READ,
      subject: Subjects.ORGANISATION,
    },
  },
  {
    path: '/:organisationId?/settings/role-capabilities',
    name: 'role-capabilities',
    component: () => import('@/views/settings/RoleCapabilities.vue'),
    meta: {
      title: t('routes.settings.roleCapabilitiesPageTitle'),
      layout: 'navigationOnly',
      requiresAuth: true,
      unguarded: 'Every signed-in user can see what each role in their organisation can do',
    },
    /**
     * Refuses only once LaunchDarkly has resolved and the flag is off.
     *
     * Context: the flag reads its default (off) until LaunchDarkly resolves after bootstrap, so
     * refusing in that window would bounce every reload of this page even with the flag on. The
     * view leaves on its own if the flag then resolves to off (the create-bulk-order pattern).
     */
    beforeEnter: () => {
      if (
        !usePermissionStore().areRoleFlagsResolved ||
        useFeatureFlagsStore().roleCapabilityOverviewEnabled
      )
        return true;
      return {
        name: 'projects',
        params: selectedOrgId.value ? { organisationId: selectedOrgId.value } : {},
      };
    },
  },
] as RouteRecordRaw[];
